import type { UserProfile } from '@/shared/utils/format-status.js';

// Estrutural em vez de `UserModel` para que `resolveDetailPermissions` (que recebe só as duas
// propriedades relevantes) possa reusar a regra em vez de duplicá-la. `UserModel` continua aceito.
export type CanAssignTechLeadUser = { isGlobalAdmin: boolean; profile: UserProfile } | null | undefined;

export function resolveCanAssignTechLead(me: CanAssignTechLeadUser): boolean {
    return me?.isGlobalAdmin || me?.profile === 'GPA' || me?.profile === 'LT';
}
